import { render, staticRenderFns } from "./RbText.vue?vue&type=template&id=1eae2960&"
import script from "./RbText.vue?vue&type=script&lang=js&"
export * from "./RbText.vue?vue&type=script&lang=js&"
import style0 from "./RbText.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports